const BASE_PATH = '/auth/staffs';
const PATIENTS_BASE_PATH = '/auth/patients';
const DASHBOARD_BASE_PATH = '/auth/admins';

// Shared auth paths for all user types (staff, patient, admin)
const SIGNIN_PATH = '/auth/signin';
const VERIFY_OTP_PATH = '/auth/verify-otp';
const LOGOUT_PATH = '/auth/logout';
const RESEND_OTP_PATH = '/auth/resend-otp';
const REFRESH_PATH = '/auth/refresh-token';
const MAGIC_LINK_PATH = '/auth/magic-link';
const REQUEST_OTP_PATH = '/auth/request-otp';
const RESEND_LINK = '/auth/resend-link';
// Multi-account sign in - see API_CONTRACT_AUTH_ACCOUNTS.md §5.3-5.5.
const SELECT_ACCOUNT_PATH = '/auth/select-account';
const ACCOUNTS_PATH = '/auth/accounts';
const SWITCH_ACCOUNT_PATH = '/auth/switch-account';
export const ROUTES = {
  // Sign-in: same for all user types
  LOGIN: SIGNIN_PATH,
  DASHBOARD_LOGIN: SIGNIN_PATH,
  REQUEST_OTP: REQUEST_OTP_PATH,
  // Verify OTP: same for all user types (response includes role: { id, name })
  VERIFY_LOGIN_OTP: VERIFY_OTP_PATH,
  DASHBOARD_VERIFY_OTP: VERIFY_OTP_PATH,

  // Resend OTP: same for all user types
  RESEND_LOGIN_OTP: RESEND_OTP_PATH,
  DASHBOARD_RESEND_OTP: RESEND_OTP_PATH,

  // Logout: same for all user types
  LOGOUT: LOGOUT_PATH,
  DASHBOARD_LOG_OUT: LOGOUT_PATH,

  // Refresh token: same for all user types
  REFRESH_TOKEN: REFRESH_PATH,
  DASHBOARD_REFRESH_TOKEN: REFRESH_PATH,

  // Magic link (phone): exchange token from link for access + user
  MAGIC_LINK: MAGIC_LINK_PATH,
  RESEND_LINK: RESEND_LINK,

  // Multi-account: pick an account after sign in, list / switch once signed in
  SELECT_ACCOUNT: SELECT_ACCOUNT_PATH,
  ACCOUNTS: ACCOUNTS_PATH,
  SWITCH_ACCOUNT: SWITCH_ACCOUNT_PATH,
};
